export interface IRecaptcha {
    ready(method: () => void): void
    execute(siteKey: string, options: ExecuteOptions): Promise<string>
}

interface ExecuteOptions {
    action: "submit"
}

declare global {
    interface Window {
        grecaptcha: IRecaptcha
    }
}

export const GRecaptcha: IRecaptcha = {
    ready() {
        /**/
    },
    execute(siteKey, options) {
        return new Promise((resolve, reject) => {
            window.grecaptcha.ready(function () {
                window.grecaptcha
                    .execute(siteKey, options)
                    .then(function (token) {
                        resolve(token)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        })
    },
}

export const loadScriptByURL = (id: string, url: string, callback: () => void) => {
    const isScriptExist = document.getElementById(id)

    if (!isScriptExist) {
        const script = document.createElement("script")
        script.type = "text/javascript"
        script.src = url
        script.id = id
        script.onload = function () {
            if (callback) callback()
        }
        document.body.appendChild(script)
    }

    if (isScriptExist && callback) callback()
}
